import base64 from './base64'
import randomNum from './randomNum'

const CH = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'

/*
 * RC4 symmetric cipher encryption/decryption
 *
 * @license Public Domain
 * @param string key - secret key for encryption/decryption
 * @param string str - string to be encrypted/decrypted
 * @return string
 */
function rc4(key, str) {
	var s = [], j = 0, x, res = '';
	for (var i = 0; i < 256; i++) {
		s[i] = i;
	}
	for (i = 0; i < 256; i++) {
		j = (j + s[i] + key.charCodeAt(i % key.length)) % 256;
		x = s[i];
		s[i] = s[j];
		s[j] = x;
	}
	i = 0;
	j = 0;
	for (var y = 0; y < str.length; y++) {
		i = (i + 1) % 256;
		j = (j + s[i]) % 256;
		x = s[i];
		s[i] = s[j];
		s[j] = x;
		res += String.fromCharCode(str.charCodeAt(y) ^ s[(s[i] + s[j]) % 256]);
	}
	return res;
}

function randomKey(len) {
    let key = ''
    for (let i = 0;i < len; i++) {
        key += CH[randomNum(0,CH.length)]
    }
    return key
}

// 加密
function encrypt(message, key) {
    let isRandomKey = false
    if (typeof key === 'undefined') {
        key = randomKey(8)
        isRandomKey = true
    }
    key = key.length >= 8 ? key.slice(0, 8) : key.concat('0'.repeat(8 - key.length))
    let c = rc4(key, message)
    c = base64.btoa(c);
    return (isRandomKey ? key : '') + c
}


// 解密
function decrypt(text, key){
    if (typeof key === 'undefined') {
        key = text.substr(0, 8)
        text = text.substr(8)
    }
    key = key.length >= 8 ? key.slice(0, 8) : key.concat('0'.repeat(8 - key.length))
    text = base64.atob(text);
    let c = rc4(key, text)
    return c
}

export default {
    rc4,
    encrypt,
    decrypt
}